import {
    SET_SELECTED_SIZE_ITEM,
    SHOW_SIZE_PICKER,
    CLOSE_SIZE_PICKER,
    SET_IS_VISIBLE,
    SET_SIZE_PICKER_OPTIONS
} from '../Actions/SizePicker.action';

const DEFAULT_STATE = {
    selectedSizeItem: undefined,
    visible: false,
    shouldClose: false,
    sizes: [],
    renderFunction: null,
    className: "",
    header: null,
    onItemSelected: null,
};

export const sizePicker = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SELECTED_SIZE_ITEM:
        case SHOW_SIZE_PICKER:
        case CLOSE_SIZE_PICKER:
        case SET_IS_VISIBLE:
        case SET_SIZE_PICKER_OPTIONS:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}